import React, { useContext, useEffect, useState } from 'react';
import Question from '../components/Question';
import '../styles/Quiz.css';
import ResultContext from '../context/ResultContext';
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../components/Spinner';
import Navbar from '../components/Navbar';
import InfeedAd from '../components/InfeedAd';
import DisplayAd from '../components/DisplayAd';
// import Cookies from 'js-cookie';

export default function Quiz(props) {
  const formatDate = (timestamp) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const HOST = process.env.REACT_APP_HOST_NAME;
  const { quizId } = useParams();
  const navigate = useNavigate();
  const { quizData, setQuizData, score, setScore, responses, setResponses } = useContext(ResultContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [localResponse, setLocalResponse] = useState([]);
  const [startTime, setStartTime] = useState(null);

  // ✅ Fetch quiz data
  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      // console.log('Fetching quiz with ID:', quizId);

      const response = await fetch(`${HOST}api/getquiz/${quizId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch quiz: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      // console.log('API Response:', data);

      // ✅ FIX: Extract quiz from the response
      const quiz = data.quiz || data;
      // console.log('Quiz data:', quiz);

      if (!quiz || !quiz.questions || quiz.questions.length === 0) {
        throw new Error('Invalid quiz data: No questions found');
      }

      setQuizData(quiz);
      // ✅ Initialize with "0" for all questions
      const initialResponses = Array(quiz.questions.length).fill("0");
      setLocalResponse(initialResponses);
      setResponses(initialResponses); // ✅ Also set in context
      setStartTime(Date.now());
    } catch (error) {
      console.error('Error fetching quiz:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Fetch data when quizId changes
  useEffect(() => {
    if (quizId) {
      fetchData();
    }
  }, [quizId]);

  const handleAnswerSelected = (option, id) => {
    // console.log(`Question ${id + 1}: Selected option ${option}`); // ✅ Debug log
    
    setLocalResponse(prevResponses => {
      const newResponses = [...prevResponses];
      newResponses[id] = option.toString(); // ✅ Ensure it's a string
      // console.log('Updated responses:', newResponses); // ✅ Debug log
      return newResponses;
    });
  };

  const onSubmit = async () => {
    if (!quizData || !quizData.questions) {
      alert('प्रश्नसंच डेटा उपलब्ध नाही');
      return;
    }

    // console.log('Submitting quiz with responses:', localResponse); // ✅ Debug log
    // console.log('Quiz answers:', quizData.questions.map(q => q.answer)); // ✅ Debug log

    let tempScore = 0;

    // ✅ Calculate score - ensure both are strings for comparison
    for (let i = 0; i < localResponse.length; i++) {
      const userAnswer = localResponse[i].toString();
      const correctAnswer = quizData.questions[i].answer.toString();
      
      // console.log(`Q${i + 1}: User=${userAnswer}, Correct=${correctAnswer}, Match=${userAnswer === correctAnswer}`);
      
      if (userAnswer === correctAnswer) {
        tempScore++;
      }
    }

    // console.log('Final score:', tempScore); // ✅ Debug log

    // ✅ Set score and responses in context BEFORE navigating
    setScore(tempScore);
    setResponses([...localResponse]); // ✅ Create a new array to ensure state update

    const endTime = Date.now();
    const timeTaken = Math.round((endTime - startTime) / 1000);

    // const userData = Cookies.get('user') ? JSON.parse(Cookies.get('user')) : null;

    // if (userData) {
    //   try {
    //     const response = await fetch(`${HOST}api/submitquiz`, {
    //       method: 'POST',
    //       headers: { 
    //         'Content-Type': 'application/json',
    //         'token': `Bearer ${Cookies.get('jwtoken')}` 
    //       },
    //       body: JSON.stringify({
    //         userId: userData._id,
    //         quizId: quizData._id,
    //         score: tempScore * 2,
    //         totalQuestions: quizData.questions.length,
    //         correctAnswers: tempScore,
    //         timeTaken: timeTaken,
    //         responses: localResponse // ✅ Send responses to backend
    //       }),
    //     });

    //     if (!response.ok) {
    //       throw new Error('Failed to submit quiz attempt');
    //     }

    //     const result = await response.json();
    //     // console.log('Quiz attempt submitted successfully:', result);
    //   } catch (error) {
    //     console.error('Error submitting quiz attempt:', error);
    //   }
    // } else {
    //   // console.log('User is not logged in. Quiz result will not be stored.');
    // }

    // ✅ Navigate after a small delay to ensure state is updated
    setTimeout(() => {
      navigate('/result');
    }, 100);
  };

  // ✅ Show loading state
  if (loading) {
    return (
      <>
        <Navbar />
        <div className="loading-container">
          <Spinner />
          <p>प्रश्नसंच लोड होत आहे...</p>
        </div>
      </>
    );
  }

  // ✅ Show error state
  if (error) {
    return (
      <>
        <Navbar />
        <div className="error-container">
          <div className="error-card">
            <div className="error-icon">❌</div>
            <h2>त्रुटी</h2>
            <p>{error}</p>
            <button 
              onClick={() => navigate('/subjects')}
              className="btn btn-primary"
            >
              विषयांकडे परत जा
            </button>
          </div>
        </div>
      </>
    );
  }

  // ✅ Show quiz not found
  if (!quizData || !quizData.questions) {
    return (
      <>
        <Navbar />
        <div className="error-container">
          <div className="error-card">
            <div className="error-icon">😕</div>
            <h2>प्रश्नसंच आढळला नाही</h2>
            <p>तुम्ही शोधत असलेला प्रश्नसंच अस्तित्वात नाही किंवा काढून टाकला गेला आहे.</p>
            <button 
              onClick={() => navigate('/subjects')}
              className="btn btn-primary"
            >
              विषयांकडे परत जा
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="quiz-header-section">
        <h1>📝 दैनिक प्रश्नसंच: {formatDate(quizData.date)}</h1>
        <h3>विषय: {quizData.caption || quizData.subject}</h3>
        <div className="quiz-info">
          <span className="quiz-info-item">
            📊 एकूण प्रश्न: {quizData.questions.length}
          </span>
          <span className="quiz-info-item">
            ⏱️ सुरू केले: {new Date(startTime).toLocaleTimeString('mr-IN')}
          </span>
        </div>
      </div>

      <div className="quiz-container">
        {quizData.questions.map((question, id) => (
          <React.Fragment key={id}>
            <Question 
              question={question} 
              onAnswerSelected={handleAnswerSelected} 
              id={id}
              selectedAnswer={localResponse[id]} // ✅ Pass selected answer to Question component
            />
            {id !== 0 && id % 6 === 0 && <InfeedAd />}
          </React.Fragment>
        ))}

        <div className="center-container">
          <button 
            className='btn btn-primary btn-lg submit-quiz-btn' 
            onClick={onSubmit}
          >
            ✅ उत्तरे सबमिट करा
          </button>
          <DisplayAd />
        </div>
      </div>
    </>
  );
}